"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __1 = require("..");
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
const RestUtils_1 = tslib_1.__importDefault(require("./RestUtils"));
class LoginInterceptor {
    constructor() {
        this.pendingRequests = [];
    }
    sendPending() {
        for (let i = 0; i < this.pendingRequests.length; i++) {
            this.pendingRequests[i].next.send(this.pendingRequests[i].request);
        }
        this.pendingRequests = [];
    }
    send(request, next, prev) {
        const moduleContext = ModuleRegistryFactory_1.default.getModuleContext();
        if (!moduleContext || !moduleContext.getConfiguration() || moduleContext.isLoginEstablished()) {
            next.send(request);
        }
        else {
            // Login not yet established. If there are multiple appservers
            // behind a load balancer with session affinity, we risk hitting
            // multiple appservers at this stage, since we probably don"t have
            // an appserver session yet. Consequently, we need to carefully
            // avoid sending multiple requests until login is established.
            this.pendingRequests.push({ next, request });
            // if (!this.loginInProgress) {
            //     this.loginInProgress = true;
            moduleContext.handleUnauthorized(true, () => this.sendPending());
            // }
        }
    }
    responseReceived(request, next, prev) {
        const response = request.response;
        if (!response) {
            prev.responseReceived(request);
            return;
        }
        this.checkIfUnauthorized(response).then(unauthorized => {
            if (unauthorized) {
                // 401 Unauthorized: Could be shared secret error or just user not being logged in yet (in SAML passive mode).
                // This is the way passive logins fail and therefore we should not try passive login now.
                // Meta redirect: Most likely a service request made after login was timed out.
                this.pendingRequests.push({ next, request });
                ModuleRegistryFactory_1.default.getModuleContext().handleUnauthorized(response.status !== 401, () => this.sendPending());
            }
            else if (response.status === 409 && response.responseText && response.responseText.indexOf("Unexpected user-id") !== -1) {
                // Means that an inconsistency have been detected between user-id used for different backend apps
                const cookiePath = RestUtils_1.default.getHostPageBaseURL();
                __1.Cookies.removeCookie("JSESSIONID", cookiePath);
                // Restart application to get in sync
                ModuleRegistryFactory_1.default.getModuleContext().restartApplication();
            }
            else {
                prev.responseReceived(request);
            }
        });
    }
    async checkIfUnauthorized(response) {
        if (response.status === 401) {
            return true;
        }
        if (response.response instanceof Blob) {
            return new Promise((resolve => {
                let reader = new FileReader();
                reader.readAsText(response.response);
                reader.onloadend = e => {
                    resolve(this.isMetaRedirect(reader.result));
                };
            }));
        }
        else if (!response.responseText) {
            return false;
        }
        else {
            return this.isMetaRedirect(response.responseText);
        }
    }
    isMetaRedirect(responseText) {
        const res = responseText.toLowerCase();
        const pos = res.indexOf("<meta ");
        if (pos > -1) {
            const end = res.indexOf(">", pos + 1);
            const urlpos = res.indexOf("url=", pos + 1);
            if (urlpos > -1 && urlpos < end) {
                let termpos = -1;
                const terminators = ["\"", "'", " ", ">"];
                for (let i = 0; i < terminators.length; i++) {
                    const tmppos = res.indexOf(terminators[i], urlpos + 1);
                    if (tmppos <= end && tmppos > -1) {
                        termpos = tmppos;
                    }
                }
                if (termpos > -1) {
                    return true;
                }
            }
        }
        return false;
    }
}
exports.default = LoginInterceptor;
//# sourceMappingURL=LoginInterceptor.js.map